/**
 * File: useAuthController.ts
 * Path: apps/admin/src/modules/auth/hooks/useAuthController.ts
 * Description: Orchestrates authentication state, profile data, and direct login/logout actions.
 */

import { useAuthQueries } from "./useAuthQueries";
import { useAuthMutations } from "./useAuthMutations";
import { useAuthUtils } from "./useAuthUtils";

export const useAuthController = () => {
  const queries = useAuthQueries();
  const mutations = useAuthMutations();
  const utils = useAuthUtils();

  const authUserQuery = queries.useCurrentUser();
  const user = authUserQuery.data;

  // Fetch the full profile only if we have an authenticated user ID
  const profileQuery = queries.useProfile(user?.uid);

  return {
    // Data
    user,
    profile: profileQuery.data ?? null,

    // Status
    isAuthenticated: !!user,
    isLoading: authUserQuery.isLoading || (!!user && profileQuery.isLoading),
    isBusy: mutations.isPending,

    // Actions
    login: mutations.login,
    loginWithGoogle: mutations.loginWithGoogle,
    logout: mutations.logout,
    requestPasswordReset: mutations.requestPasswordReset,

    // Error Handling
    error: mutations.error,

    // Helpers (Roles & Permissions)
    utils,
  };
};
